// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1OSX-","title":"Images90_title__1HQI-","images":"Images90_images__1D15-"};